<template>
	<div
		:id="uniqueId('accordion')"
		class="faq-editor"
	>
		<div class="block">
			<div
				class="block-header-default"
				:id="uniqueId('headingOne')"
			>
				<h5 class="mb-0">
					<button
						type="button"
						class="btn faq-editor__button"
						data-toggle="collapse"
						:data-target="uniqueId('#faqCollapse')"
						aria-expanded="false"
						:aria-controls="uniqueId('faqCollapse')"
					>
						<span>FAQs</span>
						<i :class="['fa','fa-chevron-right', expanded ? 'fa-rotate-90' : '']"></i>
					</button>
				</h5>
			</div>
            
			<div
				:id="uniqueId('faqCollapse')"
				class="collapse"
				:aria-labelledby="uniqueId('headingOne')"
			>
				<div class="block-content">

					<slot />

					<div class="form-check mb-2">
						<input
							v-model="selectAll"
							class="form-check-input"
							type="checkbox"
							:id="uniqueId('selectAllCheckbox')"
						>
						<label
							class="form-check-label"
							:for="uniqueId('selectAllCheckbox')"
						>Show all on mobile pass (dashboard)</label>
					</div>
                    <div
						v-for="(d, idx) in faqData"
						class="block block-header-default block-content"
					>
                        <v-chip class="mr-1 mb-2" color="red lighten-5" label light small v-if="d.mobile">
                          <span class="red--text">
                            Mobile only
                          </span>
                        </v-chip>
						<div class="form-group row">
							<label
								:for="uniqueId(`question${idx}`)"
								class="control-label col-lg-3"
							>Question</label>
							<div class="controls col-lg-9">
								<input
									v-model="d.question"
									type="text"
									:id="uniqueId(`question${idx}`)"
									class="form-control"
                                    :disabled="d.readOnly"
								>
							</div>
						</div>

						<div class="form-group row">
							<label
								:for="uniqueId(`answer${idx}`)"
								class="control-label col-lg-3"
							>Answer</label>
							<div class="controls col-lg-9">
								<tiptap-wysiwyg v-if="!d.code"
									v-model="d.answer"
									:id="uniqueId(`answer${idx}`)"
									assignment-type="faq"
								/>
                                <div v-else>
                                    <textarea
                                        v-model="d.answer"
                                        :id="uniqueId(`answer${idx}`)"
                                        class="form-control"
                                        rows="3"
                                        disabled="true"
                                    ></textarea>
                                </div>
							</div>
						</div>

						<div class="form-group row">
							<label
								:for="uniqueId(`show${idx}`)"
								class="control-label col-lg-3"
							>Show on mobile pass (dashboard)</label>
							<div class="controls col-lg-9">
								<div class="form-check">
									<input
										v-model="d.showOnMobilePass"
										class="form-check-input position-static"
										type="checkbox"
										:id="uniqueId(`show${idx}`)"
										aria-label="..."
									>
								</div>
							</div>
						</div>

						<div class="d-flex justify-content-between mb-2">
							<div>
								<button
									type="button"
									class="btn btn-secondary"
									title="move to top"
									@click="moveItem(idx, 0)"
									:disabled="idx==0"
								><i class="fa fa-arrow-up"></i>
								</button>
								<button
									type="button"
									class="btn btn-secondary"
									title="move up"
									@click="moveItem(idx, idx-1)"
									:disabled="idx==0"
								><i class="fa fa-chevron-up"></i>
								</button>
								<button
									type="button"
									class="btn btn-secondary"
									title="move down"
									@click="moveItem(idx, idx+1)"
									:disabled="idx==faqData.length - 1"
								><i class="fa fa-chevron-down"></i>
								</button>
								<button
									type="button"
									class="btn btn-secondary"
									title="move to bottom"
									@click="moveItem(idx, faqData.length - 1)"
									:disabled="idx==faqData.length - 1"
								><i class="fa fa-arrow-down"></i>
								</button>
							</div>
							<button v-if="!d.readOnly"
								@click="removeFaq(idx)"
								type="button"
								class="btn btn-danger"
							><i class="fa fa-times"/> Remove</button>
						</div>
					</div>

					<button
						@click="addFaq"
						type="button"
						class="btn btn-info"
					><i class="fa fa-plus"/> Add FAQ</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FaqEditor',
	data() {
		return {
			expanded: false,
		}
	},
	props: {
		value: {
			type: Array|String,
			default: () => [],
		}
	},
	computed: {
		selectAll: {
			get() {
				return !this.faqData.some((d) => d.showOnMobilePass === false)
			},
			set(v) {
				if(v === true) {
					this.faqData.forEach((d) => d.showOnMobilePass = true);
				} else {
					this.faqData.forEach((d) => d.showOnMobilePass = false);
				}
			}
		},
		faqData: {
			get() {
				if( this.value === '' || this.value === null ) return [];
                const defaultQuestions = {
                    'how-to-add-pass-to-my-phone': { 'question' : 'How do I add the pass to my phone?'},
                    'how-to-enable-location-services': { 'question' : 'How do I enable location services?'},
                };

                this.value.forEach((item) => {
                    if (item.code) {
                        const newQuestion = defaultQuestions[item.code] ? defaultQuestions[item.code] : {};
                        const newAnswer = { answer: '<<The answer is not editable and depends on the device>>'};
                        Object.assign(item, newQuestion, newAnswer);
                    }
                });
                return this.value;
			},
			set(v) {
				this.$emit('input', v);
			}
		},
		uuid() {
			return (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
		},
	},
	methods: {
		addFaq() {
            const newItem = {
                question: '',
                answer: '',
                showOnMobilePass: this.selectAll,
            };
            this.$set(this.faqData, this.faqData.length, newItem);
		},
		removeFaq(i) {
			Bandwango.helpers('swal', {
				title: 'Are you sure?',
				text: `This can't be undone`,
				type:'delete'
			}).then(result => {
				if (result.value) {
					this.faqData.splice(i, 1);
				}
			});
		},
		moveItem(from, to) {
			const item = this.faqData.splice(from, 1);
			this.faqData.splice(to, 0, item[0]);
		},
		uniqueId(id) {
			return `${id}-${this.uuid}`;
		}
	},
	created() {
		if (this.value === '' || this.value === null) this.$emit('input', [{
			question: '',
			answer: '',
			showOnMobilePass: false
		}]);
	},
	mounted() {
		$(`#${this.uniqueId('faqCollapse')}`).on('show.bs.collapse', () => { this.expanded = true });
		$(`#${this.uniqueId('faqCollapse')}`).on('hide.bs.collapse', () => { this.expanded = false });
	},
}
</script>

<style lang="scss">
.faq-editor {
	margin-right: -14px;
	margin-left: -14px;

	&__button {
		width: 100%;
		padding: 10px 14px;
		text-align: left;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
</style>